import { render, staticRenderFns } from "./DangerBtn.vue?vue&type=template&id=73005ba8&"
import script from "./DangerBtn.vue?vue&type=script&lang=js&"
export * from "./DangerBtn.vue?vue&type=script&lang=js&"
import style0 from "./DangerBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports